import { useContext, useRef } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import { HomePageView } from '@Views/eligibility/loan-preferences/home-page-view/HomePageView';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

export const LoanPreferencesHomePage = () => {
    const { loading } = useContext(ApplicationContext);

    const saveRef = useRef(null);

    return (
        <EligibilityLayout loading={loading} ref={saveRef}>
            <HomePageView />
        </EligibilityLayout>
    );
};
